var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstallationWhiteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.925 8.93332H12.35V2.93332C12.35 1.53332 11.5917 1.24999 10.6667 2.29999L10 3.05832L4.35834 9.47499C3.58334 10.35 3.90834 11.0667 5.07501 11.0667H7.65001V17.0667C7.65001 18.4667 8.40834 18.75 9.33334 17.7L10 16.9417L15.6417 10.525C16.4167 9.64999 16.0917 8.93332 14.925 8.93332Z",
    fill: "#F5F6FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallationWhiteIcon);
export default __webpack_public_path__ + "static/media/installation-white-icon.7e14bce1b0ea601e7084940530275faf.svg";
export { ForwardRef as ReactComponent };